import React from 'react';
import './style.scss';
import backgroundWatermark from './watermark-background.png';

const Watermark = () => (
    <img className="variation-watermark" src={backgroundWatermark} alt="Watermark"/>
);

export default Watermark;
